import React from "react";
import { filterOptions } from "./filterOptions.jsx";

const OperatorSelector = ({
  filterType,
  selectedOperator,
  onOperatorChange,
}) => {
  const filterOption = filterOptions.find((opt) => opt.type === filterType);

  if (!filterOption) return null;

  return (
    <select
      value={selectedOperator}
      onChange={(e) => {
        const selectedOperatorObj = filterOption.operators.find(
          (op) => op.key === e.target.value,
        );
        if (selectedOperatorObj) {
          onOperatorChange(selectedOperatorObj);
        }
      }}
      className="px-3 py-1 border-0.5 border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-pink focus:border-transparent min-w-[120px]"
    >
      {filterOption.operators.map((op) => (
        <option key={op.key} value={op.key}>
          {op.label}
        </option>
      ))}
    </select>
  );
};

export default OperatorSelector;
